<template>
  <footer class="page-footer grey darken-3">
    <div class="container">
        <div class="row">
        <div class="col l4 s9">
            <h5 class="white-text">Address</h5>
            <p class="grey-text text-lighten-4">
                St. George Orthodox Church, Sector 9, Dwarka, New Delhi - 110075
            </p>
            <p>
            <strong>Email:</strong> contact@abcd.com
            </p>
        </div>
        <div class="col l1 offset-l7 s12">
            <h5 class="white-text">Links</h5>
            <ul>
            <li><a class="grey-text text-lighten-3" href="#!">Home</a></li>
            <li><a class="grey-text text-lighten-3" href="#!">Vicars</a></li>
            <li><a class="grey-text text-lighten-3" href="#!">Ministries</a></li>
            <li><a class="grey-text text-lighten-3" href="#!">Management</a></li>
            </ul>
        </div>
        </div>
    </div>
    <div class="footer-copyright">
        <div class="container">
            Copyright © 2018 <a href="http://www.sidhin.in"  target="blank" class="white-text">Sidhin S Thomas</a>
        <a class="grey-text text-lighten-4 right" href="#!">More Links</a>
        </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>
p {
  text-indent: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue